import EventIcon from '@mui/icons-material/Event';

export default EventIcon;
